import React, { FC, memo, useCallback } from "react";
import { RaisedButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";
import { AddLayer } from "../AddLayer";

import { EmptyLayerListContainer, EmptyLayerListDescription, EmptyLayerListIcon, EmptyLayerListTitle } from "./styled";

export const EmptyLayerList: FC = memo(() => {
  const { t } = useTranslation("layerList");
  const AddLayerButton = useCallback(
    ({ innerRef, toggleMenu }) => (
      <RaisedButton ref={innerRef} primary onClick={toggleMenu}>
        {t("actions.add", { ns: "common" }).toUpperCase()}
      </RaisedButton>
    ),
    [t],
  );

  return (
    <EmptyLayerListContainer>
      <EmptyLayerListIcon kind="layers_add" />
      <EmptyLayerListTitle>{t("addLayers")}</EmptyLayerListTitle>
      <EmptyLayerListDescription>{t("addLayersToStart")}</EmptyLayerListDescription>
      <AddLayer Button={AddLayerButton} />
    </EmptyLayerListContainer>
  );
});
